import { NOTA_REMISION_TYPES } from "../constants/nota-remision-types";
import { ActionNR, NotaRemision, StateNR } from "../interfaces/nota-remision.interface";

const initialState: NotaRemision = {
    view: 'Formularios',

    formCliente: {
        fecha: '',
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        departamentoDescripcion: '',
        municipioDescripcion: '',
        nrc: '',
        
        datosSucursal: [],
        datosDocumento: [],

        sucursal: '',
        serie: '',
        loadedSucursal: false,
    },

    formBusquedaDocumento: {
        fechaInicial: '',
        fechaFinal: '',
        tipoDocumento: '',
        noIdentificacion: '',
        tipoIdentificacion: '',
        nombre: '',
    },

    errorsFormBusquedaDocumento: {
        fechaInicial: '',
        fechaFinal: '',
        tipoDocumento: '',
        noIdentificacion: '',
        tipoIdentificacion: '',
        nombre: '',
    },

    clienteEncontrado: {},

    formProducto: {
        servicio: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        exento: false,
        conIva: false,
        unidadMedida: '59',
    },

    productoIndex: null,

    errorsCliente: {
        fecha: '',
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: '',
        telefono: '',
        actividad: '',
        nrc: '',
    
        sucursal: '',
        serie:''
    },

    errorsProducto: {
        descripcion: '',
        cantidad: '',
        precio: '',
        descuento: '',
    },

    productos: [],
    productoEdit: {
        servicio: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        exento: false,
        conIva: false,
        unidadMedida: '59',
    },

    modal_editar: false,
    modal_eliminar: false,
    modal_quitarTodo: false,
    modal_emitir: false,
    modal_emitido: false,
    modal_masOpciones: false,
    modal_enviarCorreo: false,
    modal_imprimir: false,
    modal_anular: false,
    modal_anulado: false,
    modal_clienteEncontrado: false,
    modal_asociarDocumentosWarning: false,
    modal_buscarDocumentos: false,

    response_QRcode: '',
    response_Emitir: null,

    calculosProducto: {
        neto: '',
        subtotal: '',
        descuento: '',
        total: '',
        iva: '',
        otrosImpuestos: '',
        resumenTributos: [],
    },

    calculosGenerales: {
        subtotal: '',
        descuento: '',
        total: ''
    },

    asociarDocumentos: false,
    loader_asociarDocumentos: false,
    documentosEncontrados: [],
    documentosAsociados: [],
    mostrarDetalle: true,
    tableProductos: [],
    modal_documentoFisico: false,
    modal_agregarProductoFisico: false,
    modal_editarProductoFisico: false
}

const notaRemisionReducer = ( state: NotaRemision = initialState, action: ActionNR ) : StateNR => { 
    switch (action.type) {
        case NOTA_REMISION_TYPES.NR_SET_FORM_CLIENTE: return {...state, formCliente: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_FORM_PRODUCTO: return {...state, formProducto: action.payload}
        case NOTA_REMISION_TYPES.NR_HANDLE_ERRORS_CLIENTE: return {...state, errorsCliente: action.payload}
        case NOTA_REMISION_TYPES.NR_HANDLE_ERRORS_PRODUCTO: return {...state, errorsProducto: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_VIEW: return {...state, view: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_PRODUCTOS: return {...state, productos: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_PRODUCTO_EDIT: return {...state, productoEdit: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_PRODUCTO_INDEX: return {...state, productoIndex: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_EDITAR_PRODUCTO: return {...state, modal_editar: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_ELIMINAR_PRODUCTO: return {...state, modal_eliminar: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_QUITAR_TODO: return {...state, modal_quitarTodo: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_EMITIR: return {...state, modal_emitir: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_EMITIDO: return {...state, modal_emitido: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_MAS_OPCIONES: return {...state, modal_masOpciones: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_ENVIAR_CORREO: return {...state, modal_enviarCorreo: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_ANULAR: return {...state, modal_anular: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_ANULADO: return {...state, modal_anulado: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_IMPRIMIR: return {...state, modal_imprimir: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_CALCULOS_PRODUCTO: return {...state, calculosProducto: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_CALCULOS_GENERALES: return {...state, calculosGenerales: action.payload}
        case NOTA_REMISION_TYPES.NR_RESTART_FORM_PRODUCTO: return {...state, formProducto: initialState.formProducto}
        case NOTA_REMISION_TYPES.NR_SET_QR_CODE: return {...state, response_QRcode: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_RESPONSE_EMITIR: return {...state, response_Emitir: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_CLIENTE_ENCONTRADO: return {...state, clienteEncontrado: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_CLIENTE_ENCONTRADO: return {...state, modal_clienteEncontrado: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_ASOCIAR_DOCUMENTOS: return{...state, asociarDocumentos: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_DOCUMENTOS_ENCONTRADOS: return{...state, documentosEncontrados: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_DOCUMENTOS_ASOCIADOS: return{...state, documentosAsociados: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_LOADER_DOCUMENTOS_ASOCIADOS: return{...state, loader_asociarDocumentos: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_ADVERTENCIA_ASOCIAR_DOCUMENTOS: return{...state, modal_asociarDocumentosWarning: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_FORM_BUSQUEDA_DOCUMENTO: return{...state, formBusquedaDocumento: action.payload}
        case NOTA_REMISION_TYPES.NR_HANDLE_ERRORS_BUSQUEDA_DOCUMENTO: return{...state, errorsFormBusquedaDocumento: action.payload}
        case NOTA_REMISION_TYPES.NR_HANDLE_ACTIVE_MOSTRAR_DETALLE: return{...state, mostrarDetalle: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_BUSQUEDA_DOCUMENTO: return{...state, modal_buscarDocumentos: action.payload}
        case NOTA_REMISION_TYPES.NR_SET_TABLE_PRODUCTOS: return{...state, tableProductos: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_DOCUMENTO_FISICO: return {...state, modal_documentoFisico: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_PRODUCTO_FISICO: return {...state, modal_agregarProductoFisico: action.payload}
        case NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_EDITAR_PRODUCTO_FISICO: return {...state, modal_editarProductoFisico: action.payload}

        case NOTA_REMISION_TYPES.NR_RESTART_ALL: return {...initialState, productos: [], documentosAsociados: [], documentosEncontrados: []}
        default: return state;
    }
}

export default notaRemisionReducer